import { call, put, takeEvery } from "redux-saga/effects";
import AXIOS_INSTANCE from "../../utils/Config";
import axios from "axios";

import {
  customerListLoading,
  submitCustomersActionDispatcher,
  submitCustomersErrorDispatcher,
  SUBMIT_CUSTOMERS_ACTION_REQUESTED,
} from "./Action"; // Path should come here
import UPTIMEApirequest from "../../utils/ApiUrls";
import { getAuthUserDetails } from "../../utils/Helpers";

const postCustomersAPI = async (postData) => {
  const newData={
    Token:"teramatrix",
    UserId:getAuthUserDetails()?.UserId,
    ...postData
  }
  
  const result = await axios.post(UPTIMEApirequest.UPTIMEApiBaseURL+`/CustomerPortal/UserCustomerDetailList?customerlist=true`, {
    ...newData,
  });
  return result;
};

function* submitCustomersSaga({ postData }) {
  try {
    yield put(customerListLoading(true));
    const data = yield call(postCustomersAPI, postData);
    yield put(submitCustomersActionDispatcher(data));
    yield put(submitCustomersErrorDispatcher({}));
    yield put(customerListLoading(false));
  } catch (e) {
    yield put(submitCustomersActionDispatcher({}));
    
    yield put(customerListLoading(false));
  }
}

function* submitCustomersWatcher() {
  yield takeEvery(SUBMIT_CUSTOMERS_ACTION_REQUESTED, submitCustomersSaga);
}
export default submitCustomersWatcher;
